import server from '../request/encryptRequest.js';

// ============================= 业务端接口（需登录） =============================

/** 创建活动 */
export const activityCreate = (params) =>
  server.post('/xiaozi-xmo/wireless/saas/activity/create', params);

/** 修改活动基本信息 */
export const activityUpdate = (params) =>
  server.post('/xiaozi-xmo/wireless/saas/activity/update', params);

/** 开启活动（生成二维码） */
export const activityOpen = (params) =>
  server.post('/xiaozi-xmo/wireless/saas/activity/open', params);

/** 关闭活动 */
export const activityClose = (params) =>
  server.post('/xiaozi-xmo/wireless/saas/activity/close', params);

/** 活动分页列表 */
export const activityPageList = (params) =>
  server.post('/xiaozi-xmo/wireless/saas/activity/pageList', params);

/** 活动详情 */
export const activityDetail = (params) =>
  server.post('/xiaozi-xmo/wireless/saas/activity/detail', params);

/** 保存活动资料（策划页） */
export const activitySaveMaterials = (params) =>
  server.post('/xiaozi-xmo/wireless/saas/activity/saveMaterials', params);

/** 活动进展-访客分页列表 */
export const activityVisitorPageList = (params) =>
  server.post('/xiaozi-xmo/wireless/saas/activity/visitorPageList', params);

/** 活动进展-导出访客列表 */
export const activityVisitorExportList = (params) =>
  server.post('/xiaozi-xmo/wireless/saas/activity/visitorExportList', params);

/** 活动日志列表 */
export const activityLogList = (params) =>
  server.post('/xiaozi-xmo/wireless/saas/activity/logList', params);

// ============================= 开放接口（客户端无需登录） =============================

/** 客户端获取活动详情 */
export const openActivityDetail = (params) =>
  server.post('/xiaozi-xmo/wireless/saas/activity/openDetail', params);

/** 客户端发送验证码 */
export const openActivitySendVerifyCode = (params, config) =>
  server.post('/xiaozi-xmo/wireless/saas/activity/sendVerifyCode', params, config);

/** 客户端验证身份并记录访客（返回 visitorId 作为下载凭证） */
export const openActivityVerifyAndRecord = (params, config) =>
  server.post('/xiaozi-xmo/wireless/saas/activity/verifyAndRecord', params, config);

/** 获取单个资料代理下载 URL */
export const getActivityDownloadUrl = (visitorId, materialId) => {
  const base = (process.env.VUE_APP_HOST || '').replace(/\/$/, '');
  return `${base}/xiaozi-xmo/wireless/saas/activity/downloadMaterial?visitorId=${visitorId}&materialId=${materialId}`;
};

/** 获取多个资料批量打包（ZIP）下载 URL */
export const getActivityDownloadMaterialsUrl = (visitorId, materialIds) => {
  const base = (process.env.VUE_APP_HOST || '').replace(/\/$/, '');
  const ids = materialIds.map((id) => `materialIds=${id}`).join('&');
  return `${base}/xiaozi-xmo/wireless/saas/activity/downloadMaterials?visitorId=${visitorId}&${ids}`;
};
